module.exports = __webpack_public_path__ + "img/红豆蔻.d42880b6.jpg";